import { C } from "../theme";
import { Card } from "./Card";
import { Label } from "./Label";

interface KpiCardProps {
  label: string;
  value: string;
  sub: string;
  /** Versão em destaque (fundo lime suave, borda lime). */
  highlight?: boolean;
}

/** Cartão de métrica (label + valor grande + subtítulo). */
export function KpiCard({ label, value, sub, highlight }: KpiCardProps) {
  return (
    <Card style={highlight ? { borderColor: C.lime, background: C.limeSoft } : undefined}>
      <Label style={highlight ? { color: C.gray } : undefined}>{label}</Label>
      <div style={{ fontSize: 24, fontWeight: 700, color: C.ink }}>{value}</div>
      <div style={{ fontSize: 11.5, color: highlight ? C.gray : C.light }}>{sub}</div>
    </Card>
  );
}
